import CalculatorSection, { ICalculatorSection } from "./components/CalculatorSection/CalculatorSection";
import CardSection, { ICardSection } from "./components/CardSection/CardSection";
import Section, { ISection, Image } from "./components/Section/Section";

import React from "react";
import SectionPageContext from "./SectionPageContext";
import { UmbracoNotification } from "@bn-monorepo/js-packages";
import SectionPageNotification from "./components/Section/SectionPageNotification";
import { AuthorSection } from "./components/AuthorInfo/AuthorSection";
import { PublishInfoSection } from "./components/PublishInfo/PublishInfoSection";
import { TableOfContents } from "./components/TableOfContents/TableOfContents";
interface ArticleAuthorPhoto {
  alias: string;
  id: number;
  url: string;
  alt: string;
  height: number;
  width: number;
  fileExtension: string;
}

export interface ArticleAuthor {
  name: string;
  biography: string;
  photo?: ArticleAuthorPhoto;
}

export interface ArticleSettings {
  image?: Image;
  heading?: string;
  author?: ArticleAuthor;
  displayDates?: boolean;
  createDate: Date;
  updateDate: Date;
  displayEstimatedReadTime?: boolean;
  numberOfWordsToRead?: number;
  tableOfContents?: [];
}
interface LayoutOverrides {
  textSectionContainerMaxWidth: string;
  sectionImageWidth: string;
  sectionImageBorderRadius: string;
}

interface Props {
  articleSettings?: ArticleSettings;
  contentList: any[];
  layoutOverrides?: LayoutOverrides;
  notificationList: UmbracoNotification[];
}

const articleLayoutDefaults: LayoutOverrides = {
  textSectionContainerMaxWidth: "72rem",
  sectionImageWidth: "100%",
  sectionImageBorderRadius: "1.6rem",
};

const SectionPage: React.FC<Props> = ({ articleSettings, contentList, layoutOverrides, notificationList }) => {
  const resolveComponent = (component: any, index: number) => {
    switch (component.alias) {
      case "section": {
        const section = component as ISection;
        return <Section {...section} key={`section-${index}`} isFirst={index === 0} />;
      }
      case "cardSection": {
        const cardSection = component as ICardSection;
        return <CardSection {...cardSection} key={`section-${index}`} />;
      }
      case "calculatorSection": {
        const calculatorSection = component as ICalculatorSection;
        return <CalculatorSection {...calculatorSection} key={`section-${index}`} />;
      }
    }
    throw new Error(`Component type=${component.type} not found`);
  };
  const isArticle = !!articleSettings?.heading;
  const layoutDefaults = isArticle ? articleLayoutDefaults : undefined;
  return (
    <SectionPageContainerWrapper>
      {!!notificationList?.length && <SectionPageNotification notificationList={notificationList} />}
      <SectionPageContext.Provider
        value={{
          sectionImageWidthOverride: layoutOverrides?.sectionImageWidth || layoutDefaults?.sectionImageWidth,
          sectionImageBorderRadiusOverride:
            layoutOverrides?.sectionImageBorderRadius || layoutDefaults?.sectionImageBorderRadius,
          textSectionContainerMaxWidthOverride:
            layoutOverrides?.textSectionContainerMaxWidth || layoutDefaults?.textSectionContainerMaxWidth,
          isArticle,
        }}
      >
        <PublishInfoSection articleSettings={articleSettings} />
        <TableOfContents tableOfContents={articleSettings?.tableOfContents} />
        {contentList.map(resolveComponent)}
        <AuthorSection author={articleSettings?.author} />
      </SectionPageContext.Provider>
    </SectionPageContainerWrapper>
  );
};
interface SectionPageContainerWrapperProps {
  children?: React.ReactNode;
}
export const SectionPageContainerWrapper: React.FC<SectionPageContainerWrapperProps> = (props) => (
  <main>{props.children}</main>
);

export default SectionPage;
